import { render, staticRenderFns } from "./NegociacaoDiffDadosProdutos.vue?vue&type=template&id=070f23fc"
import script from "./NegociacaoDiffDadosProdutos.vue?vue&type=script&lang=js"
export * from "./NegociacaoDiffDadosProdutos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports